import { useState } from 'react';
import { useDownloads } from './DownloadActivityProvider';
import { DownloadActivityCard } from './DownloadActivityCard';
import { btn } from '../actions';
export function DownloadTray(){
  const {store,activities}=useDownloads();const [expanded,setExpanded]=useState(false);
  const visible=activities.filter(a=>!a.inline&&(!a.hidden||expanded));
  if(!activities.some(a=>!a.inline))return null;
  return <aside className="download-tray" aria-label="Downloads"><button className={btn('plain')} aria-expanded={expanded} onClick={()=>setExpanded(v=>!v)}>Downloads · {activities.length}</button><div className="download-tray-items">{visible.slice(-3).map(a=><DownloadActivityCard key={a.key} activity={a} compact onRetry={()=>void store.retry(a.key)} onDownload={()=>void store.handoff(a.key)} onHide={()=>store.hide(a.key)}/>)}</div></aside>;
}
